import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

/** Resolve a possibly-relative /api/uploads/* URL against the backend host
 *  so <img src> works regardless of frontend vs backend domain split. */
export function resolveImageUrl(u) {
  if (!u) return null;
  if (u.startsWith("http://") || u.startsWith("https://")) return u;
  if (u.startsWith("/api/")) return BACKEND_URL + u;
  return u;
}

const client = axios.create({
  baseURL: API,
  withCredentials: true,
});

export default client;
